import { MoneyLinkException } from "@/shared/utils/custom-exception";
import { ApiClient } from "@/shared/services/api-client";
import {
  DeleteSearchConditionsDeleteRequestModel,
  DeleteSearchConditionsDeleteResponseModel
} from "@/features/accounts/shared/services/delete-search-conditions-model";

export class DeleteSearchConditionsApi {
  /**
   * 検索条件削除API
   */
  public deleteSearchConditions = async (
    param: DeleteSearchConditionsDeleteRequestModel
  ): Promise<DeleteSearchConditionsDeleteResponseModel> => {
    const path = `/api/searchconditions`;
    const res = await ApiClient.instance.delete<DeleteSearchConditionsDeleteResponseModel>({
      path: path,
      params: param as NonNullable<unknown>,
    });

    if (res.ok === false) {
      throw MoneyLinkException.fromServer({ response: res });
    }

    return res.body;
  };
}
